import { Box, CircularProgress } from '@material-ui/core';

function SuspenseLoader({ phase = '' }) {
	return (
		<Box
			sx={{
				position: 'fixed',
				left: 0,
				top: 0,
				width: '100%',
				height: '100%',
			}}
			display='flex'
			alignItems='center'
			justifyContent='center'
			className='gap-4'
		>
			<CircularProgress size={16} disableShrink thickness={3} />
			<div>{phase}</div>
		</Box>
	);
}

export default SuspenseLoader;
